module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp3_9006.8c15ae90.png";